import styled from 'styled-components';
import { Star, Star_01 } from '@hqo/react-components-library/dist/icons';

export const FavoriteButtonContainer = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: 50%;
  }
`;

export const FilledStarIcon = styled(Star)`
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.palette.systemGold};
`;

export const OutlineStarIcon = styled(Star_01)`
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.palette.systemGreyDark};
`;
